import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSnakbar } from 'actions/app_action';
import SnackbarComponent from 'components/snackbar-component';
import Snackbar from 'components/snackbar';
import { useTypedSelector } from 'hooks/use-typed-selector';

const GlobalSnackbar = () => {
  const dispatch = useDispatch();
  const snackbar = useTypedSelector(state => state.app.snackbar);
  const snackbarComponent = useTypedSelector(state => state.app.snackbarComponent);

  const closeSnackbar = useCallback(() => {
    dispatch(
      setSnakbar({
        ...snackbar,
        isOpen: false
      })
    );
  }, [dispatch, snackbar]);

  return (
    <>
      <Snackbar
        open={snackbar.isOpen}
        type={snackbar.type}
        time={typeof snackbar.time === 'number' ? snackbar.time : 6000}
        onClose={typeof snackbar.onClose === 'function' ? snackbar.onClose : closeSnackbar}
        message={snackbar.message}
      />
      <SnackbarComponent
        open={snackbarComponent.open}
        type={snackbarComponent.type}
        component={snackbarComponent.component}
      />
    </>
  );
};

export default memo(GlobalSnackbar);
